/*
* @Description: ����APIά��
* @Author: fxg
* @Date: 2020-06-29 11:18:28
* @LastEditors: wangwangwang
* @LastEditTime: 2020-08-05 19:25:09
*/
import request from '@/utils/request'
export function updateStatus(data) {
  return request({
    url: '/third/system/base/foreignapi/update_status',
    method: 'post',
    data
  })
}
export function queryPage(data) {
  return request({
    url: '/third/system/base/foreignapi/query_page',
    method: 'post',
    data
  })
}
export function saveOrUpdate(data) {
  return request({
    url: '/third/system/base/foreignapi/save_or_update',
    method: 'post',
    data
  })
}
export function Export(data) {
  return request({
    url: '/third/system/base/foreignapi/export',
    method: 'post',
    data
  })
}

